import { Alert } from ".";
import { List } from "immutable";
import * as React from "react";
import { connect } from "react-redux";
import * as redux from "redux";
import * as Actions from "../../actions";
import * as M from "../../models";
import { AppState } from "../../store";
import { DefaultConnectedDispatch, DefaultConnectedState, DefaultDispatchPropsMap, DefaultStatePropsMap } from "../base";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    ...DefaultStatePropsMap(state, ownProps),
    alerts: state.alert.alerts,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    ...DefaultDispatchPropsMap(dispatch),
    dismiss: (id: number) => dispatch(Actions.Alert.onDismissed(id)),
});

interface OwnProps {
}

type ConnectedState = DefaultConnectedState & {
    alerts: List<M.Alert.Alert>;
};

type ConnectedDispatch = DefaultConnectedDispatch & {
    dismiss: (id: number) => void;
};

interface OwnState {
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class AlertsComponent extends React.Component<CombinedProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    public render() {
        return this.props.alerts
            .filter((x: M.Alert.Alert) => !x.dismissed)
            .map((x: M.Alert.Alert, i) => (
                <Alert key={i} dismissHandler={() => this.handleDismiss(x.id)} type={x.type} title={x.title as any}>
                    {x.message}
                </Alert>
            ));
    }

    private handleDismiss(id: number) {
        this.props.dismiss(id);
    }
}

export const Alerts: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(AlertsComponent);



// WEBPACK FOOTER //
// ./src/components/generic/Alerts.tsx